import { useContext, useEffect } from "react";
import { DashboardSetupContext } from "./home/dashboardSetupContext";
import { Link } from "react-router-dom";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

export const DashboardSetupAlertLink = ({ to, icon: Icon, title, subtitle, count = 0 }) => {
  const register = useContext(DashboardSetupContext);
  useEffect(() => {
    register?.(to, count);
    return () => register?.(to, null);
  }, [register, to, count]);
  return (
  <Link
    to={to}
    className="flex items-center gap-2.5 rounded-xl border border-amber-200 bg-amber-50/50 px-3 py-2.5 shadow-sm transition hover:border-amber-300 active:bg-amber-50 sm:gap-3 sm:rounded-2xl sm:px-4 sm:py-3"
  >
    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white text-amber-800 shadow-sm sm:h-10 sm:w-10 sm:rounded-xl">
      <Icon className="h-4 w-4 sm:h-5 sm:w-5" />
    </div>
    <div className="min-w-0 flex-1">
      <div className="text-xs font-semibold leading-tight text-slate-900 sm:text-sm">{title}</div>
      {subtitle ? (
        <div className="mt-0.5 text-[11px] leading-snug text-slate-600 sm:text-xs">{subtitle}</div>
      ) : null}
    </div>
    {register && count > 0 && <span className="pd-setup-count">{count}</span>}
    <ChevronRightIcon className="h-5 w-5 shrink-0 text-slate-400" />
  </Link>
);
};
